import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=0f4aa81e&scoped=true"
import script from "./CreateNews.vue?vue&type=script&lang=js"
export * from "./CreateNews.vue?vue&type=script&lang=js"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=0f4aa81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4aa81e",
  null
  
)

export default component.exports